export default __webpack_public_path__ + "static/media/create-account.c70bca9f.png";